import type { ReactNode } from "react";
import {
  scrollableOuterStyle,
  scrollableInnerStyle,
} from "./scrollable-table-style";

interface ScrollableTableProps {
  minWidth: number;
  children: ReactNode;
}

/**
 * Wraps a dense "fake table" (CSS-grid or native <table>) so that on a narrow
 * viewport it scrolls horizontally instead of clipping. The minWidth is applied
 * to the inner element so header + body share the same track widths and stay
 * column-aligned. Desktop is unaffected (the outer div is full-width; the inner
 * minWidth is <= the available width, so no scrollbar appears).
 */
export function ScrollableTable({ minWidth, children }: ScrollableTableProps) {
  return (
    <div style={scrollableOuterStyle}>
      <div style={scrollableInnerStyle(minWidth)}>{children}</div>
    </div>
  );
}
